import { gql } from 'react-apollo';

export default gql`
  query offerComments($offerId: ID!) {
    offerComments(offerId: $offerId) {
      _id
      content
      title
      createdAt
      updatedAt
      adminCommentModerator
      postedBy
      investorUser {
        _id
        adminCommentModerator
      }
      replies {
        _id
        text
        createdAt
        repliedBy
        commentModeratorTitle
      }
      likes {
        _id
        createdAt
        investorUserId
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/offerComments.js